// src/utils/localDB.js
import { openDB } from "idb";

const DB_NAME = "customerApp";
const STORE_NAME = "customers";
const DB_VERSION = 1;

async function initDB() {
  return openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: "id", autoIncrement: true });
      }
    },
  });
}

export async function saveCustomer(customer) {
  const db = await initDB();
  const tx = db.transaction(STORE_NAME, "readwrite");

  if (!customer.id) {
    customer.id = Date.now(); // or crypto.randomUUID()
  }
  await tx.store.put(customer);
  await tx.done;
}

export async function saveCustomers(customers) {
  const db = await initDB();
  const tx = db.transaction(STORE_NAME, "readwrite");
  const store = tx.objectStore(STORE_NAME);
  await store.clear();
  customers.forEach((customer) => store.put(customer));
  await tx.done;
}

export async function getAllCustomers() {
  const db = await initDB();
  console.log(db);
  const customers = await db.getAll(STORE_NAME)
  console.log(customers);
  return customers ;
}

export async function deleteCustomer(id) {
  const db = await initDB();
  const tx = db.transaction(STORE_NAME, "readwrite");
  const store = tx.objectStore(STORE_NAME);
  await store.delete(id);
  await tx.done;
}
